// project imports
import { withAlpha } from 'utils/colorUtils';
import { CustomShadows } from 'mui.d';

// ==============================|| DEFAULT THEME - CUSTOM SHADOWS ||============================== //

export default function CustomShadowsFn(palette: Record<string, unknown>): CustomShadows {
  const grey = palette.grey as Record<string | number, string>;
  const primary = palette.primary as { main: string };
  const secondary = palette.secondary as { main: string };
  const error = palette.error as { main: string };
  const warning = palette.warning as { main: string };
  const info = palette.info as { main: string };
  const success = palette.success as { main: string };

  return {
    button: `0 2px #0000000b`,
    text: `0 -1px 0 rgb(0 0 0 / 12%)`,
    z1: `0px 1px 4px ${withAlpha(grey[900], 0.08)}`,
    primary: `0 0 0 2px ${withAlpha(primary.main, 0.2)}`,
    secondary: `0 0 0 2px ${withAlpha(secondary.main, 0.2)}`,
    error: `0 0 0 2px ${withAlpha(error.main, 0.2)}`,
    warning: `0 0 0 2px ${withAlpha(warning.main, 0.2)}`,
    info: `0 0 0 2px ${withAlpha(info.main, 0.2)}`,
    success: `0 0 0 2px ${withAlpha(success.main, 0.2)}`,
    grey: `0 0 0 2px ${withAlpha(grey[500], 0.2)}`,
    primaryButton: `0 14px 12px ${withAlpha(primary.main, 0.2)}`,
    secondaryButton: `0 14px 12px ${withAlpha(secondary.main, 0.2)}`,
    errorButton: `0 14px 12px ${withAlpha(error.main, 0.2)}`,
    warningButton: `0 14px 12px ${withAlpha(warning.main, 0.2)}`,
    infoButton: `0 14px 12px ${withAlpha(info.main, 0.2)}`,
    successButton: `0 14px 12px ${withAlpha(success.main, 0.2)}`,
    greyButton: `0 14px 12px ${withAlpha(grey[500], 0.2)}`
  };
}
